import config from 'config'
import { User } from 'state/user/UserState'

import { HomeTabPath } from './types'

export default function getHomeLink(
    user: User | undefined,
    path: HomeTabPath,
): string {
    if (path === 'mower-dealer-news') {
        if (user?.dealership?.isAgreementSignedWithHnb) {
            return 'https://octane.co/o/hnb-news/'
        }
    }

    if (path === 'hnb-signup') {
        return 'https://octane.co/o/hb-leads/'
    }

    return `${config.NEWS_IFRAME_BASE_URL}/${path}/#`
}
